import React from "react";
import { useLocation } from "react-router-dom";
import github from "../assets/images/github.png";
import "./header.css";

const Header = () => {
    const location = useLocation();

    const getHeading = () => {
        switch (location.pathname) {
            case "/":
                return "Dashboard";
            case "/customer":
                return "Customer";
            case "/order":
                return "Order";
            case "/product":
                return "Product";
            case "/about":
                return "About";
            // Add more cases as needed for other routes
            default:
                return "Dashboard"; // Default heading
        }
    };

    return (
        <section>
            <div className="pages" style={{ width: "100%" }}>
                <nav>
                    <h4>{getHeading()}</h4>
                    <div>
                        <a href="https://github.com/ABINAYA2903516">
                            <img src={github} alt="logo" />
                        </a>
                    </div>
                </nav>
            </div>
        </section>
    );
};

export default Header;

